var isTrue = function (value) {
    return value === true || value === 1 || value === "1" || value === "true";
};
var isFalse = function (value) {
    return value === false || value === 0 || value === "0" || value === "false";
};
export var displaysNonCoreItems = function () {
    var _a;
    if (typeof window === "undefined") {
        return true;
    }
    var session = window.session;
    return !isFalse((_a = session === null || session === void 0 ? void 0 : session.store) === null || _a === void 0 ? void 0 : _a.display_non_core_items);
};
export var shouldDisplayMenuEntity = function (entity) {
    return displaysNonCoreItems() || isTrue(entity === null || entity === void 0 ? void 0 : entity.is_core);
};
